import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';

import history from './history';
// import apolloClient from 'core/api/apollo/apollo';

const middleware = applyMiddleware(
	thunk,
	reduxImmutableStateInvariant(),
	routerMiddleware(history),
	/* apolloClient.middleware() */
);

export default middleware;



// WEBPACK FOOTER //
// ./src/core/store/middleware.dev.ts